import { useRef } from "react";
import { useShallow } from "zustand/shallow";

import { useBoundStore } from "@/app/store";
import { TagFormContent, TagFormValues } from "./TagFormContent";
import { DrawerAndModal } from "@/shared/components/common/DrawerAndModal";

interface ManageTagProps {
  id: string;
  initialValues?: TagFormValues;
  isOpen: boolean;
  onDelete: () => void;
  onSave: (values: TagFormValues) => Promise<void>;
  onOpenChange: (open: boolean) => void;
}

export function ManageTag({ id, initialValues, isOpen, onDelete, onOpenChange, onSave }: ManageTagProps) {
  const deviceType = useBoundStore(useShallow((state) => state.device.type));
  const formRef = useRef<{ submit: () => void; reset: () => void } | null>(null);

  const handleOpenChange = (open: boolean) => {
    onOpenChange(open);
    if (!open) {
      formRef.current?.reset();
    }
  };

  return (
    <DrawerAndModal
      id={id}
      title={initialValues ? "Edit tag" : "New tag"}
      closeLabel="Cancel"
      confirmLabel={initialValues ? "Save" : "Create"}
      onConfirm={() => formRef.current?.submit()}
      externalState={{ isOpen, onOpenChange: handleOpenChange }}
    >
      <TagFormContent
        ref={formRef}
        initialValues={initialValues}
        deviceType={deviceType}
        onClose={() => handleOpenChange(false)}
        onDelete={onDelete}
        onSubmit={onSave}
      />
    </DrawerAndModal>
  );
}
